import ourWork from './assets/aboutUs/ourStory.svg';
import ourStrengths from './assets/aboutUs/ourStrengths.svg';
import clientCentric from './assets/aboutUs/client-centric.svg';
import recognition from './assets/aboutUs/recognition.svg';
import saadAli from './assets/team/saad-ali.jpg';
import muhammadFaizan from './assets/team/muhammad-faizan.jpeg';
import steveJobs from './assets/aboutUs/steve-jobs.png';
import satyaNadella from './assets/aboutUs/satya-nadella.png';
import elonMusk from './assets/aboutUs/elon-musk.png';
import markZuckerberg from './assets/aboutUs/mark-zuckerberg.png';
import female1 from './assets/testimonials/female1.jpg';
import female2 from './assets/testimonials/female2.jpg';
import female3 from './assets/testimonials/female3.jpg';
import female4 from './assets/testimonials/female4.jpg';
import female5 from './assets/testimonials/female5.jpg';
import male1 from './assets/testimonials/male1.jpg';
import male2 from './assets/testimonials/male2.jpg';
import male3 from './assets/testimonials/male3.jpg';
import male4 from './assets/testimonials/male4.jpg';
import male5 from './assets/testimonials/male5.jpg';
import male6 from './assets/testimonials/male6.jpg';
import mobileDevelopment from './assets/services/mobile-development.png';
import analytics from './assets/services/analytics.png';
import cloudApp from './assets/services/cloud-app.png';
import enterpriseDevelopment from './assets/services/enterprise-development.png';
import eCommerce from './assets/services/e-commerce.png';
import webDevelopment from './assets/services/web-development.png';
import uiUx from './assets/services/ui-ux.png';
import salesforce from './assets/services/salesforce.png';
import freeConsult from './assets/services/free-consult.png';
import customDevelopment from './assets/services/custom-development.png';
import innovation from './assets/values/innovation.png';
import customerFocus from './assets/values/customer-focus.png';
import collaboration from './assets/values/collaboration.png';
import quality from './assets/values/quality.png';
import reliability from './assets/values/reliability.png';
import integrity from './assets/values/integrity.png';

export const linkItems = [
  { name: 'home', href: '/' },
  { name: 'about us', href: '/about' },
  { name: 'services', href: '/services' },
  { name: 'our work', href: '/our-work' },
  { name: 'blog', href: '/blogs' },
  { name: 'careers', href: '/careers' }
];

export const quotes = [
  {
    id: 1,
    quote: 'Innovation distinguishes between a leader and a follower.',
    author: 'Steve Jobs',
    image: steveJobs
  },
  {
    id: 2,
    quote:
      'Innovation is the result of leaders who are not afraid to challenge the status quo.',
    author: 'Elon Musk',
    image: elonMusk
  },
  {
    id: 3,
    quote:
      'Our industry does not respect tradition; it only respects innovation.',
    author: 'Satya Nadella',
    image: satyaNadella
  },
  {
    id: 4,
    quote: 'The only strategy that is guaranteed to fail is not taking risks.',
    author: 'Mark Zuckerberg',
    image: markZuckerberg
  }
];

export const ourValues = [
  {
    id: '01',
    image: innovation,
    title: 'Innovation',
    description:
      "We are always looking for new and innovative ways to solve our customers' problems."
  },
  {
    id: '02',
    image: customerFocus,
    title: 'Customer focus',
    description:
      'We are committed to building long-term relationships with our customers, and we believe that the best way to do that is to provide them with the best possible service.'
  },
  {
    id: '03',
    image: collaboration,
    title: 'Collaboration',
    description:
      'We believe that we can achieve more by working together than we can by working alone.'
  },
  {
    id: '04',
    image: quality,
    title: 'Quality',
    description:
      'Committed to excellence in everything we do, Colossal Innovations strives to deliver the highest quality software solutions that exceed expectations.'
  },
  {
    id: '05',
    image: reliability,
    title: 'Reliability',
    description:
      "Let us be the foundation of reliability for your business, so you can focus on what matters most – achieving your goals and exceeding your customers' expectations."
  },
  {
    id: '06',
    image: integrity,
    title: 'Integrity',
    description:
      'We are committed to conducting our business in an ethical and responsible manner.'
  }
];

export const aboutUs = [
  {
    id: 1,
    image: ourWork,
    alt: 'Our story',
    title: 'Our story',
    description:
      'Colossal Innovations (PVT) Limited (CI) is a highly respected IT services provider based in Pakistan. With our expertise in diverse domains such as Full Stack Development, Business Analytics, and Data Science, we have established ourselves as a trusted partner in delivering onsite and offshore professional services.'
  },
  {
    id: 2,
    image: ourStrengths,
    alt: 'Our strengths',
    title: 'Our strengths',
    description:
      'At Colossal Innovations, our strength lies in our ability to empathize with our clients, strategize effectively, and leverage cutting-edge technologies and industry best practices. Through resource augmentation and managed services, we assist businesses in optimizing their IT spending while increasing efficiency and effectiveness.'
  },
  {
    id: 3,
    image: clientCentric,
    alt: 'Customer focus',
    title: 'Client-centric approach',
    description:
      "We firmly believe in working closely with our clients, understanding their unique requirements and goals. By doing so, we develop practical solutions that drive success and help businesses thrive in today's competitive landscape. With a team of experienced professionals and a commitment to excellence, we are dedicated to empowering businesses to modernize their legacy systems and transform into competitive players in their respective industries."
  },
  {
    id: 4,
    image: recognition,
    alt: 'Recognition',
    title: 'Industry recognition',
    description:
      'As esteemed members of the Telecom Forum and World Economic Forum, we remain at the forefront of industry trends. This ensures that our clients benefit from the latest advancements in technology and strategic insights, allowing them to stay ahead of the curve and achieve their business objectives.'
  }
];

export const testimonials = [
  {
    quote:
      'Working with Colossal Innovation has been a game-changer for our business. Their expertise in data analytics and custom software development has revolutionized the way we operate. Thanks to their solutions, we have seen a significant increase in efficiency and profitability. Highly recommend their services!',
    author: 'John Smith',
    position: 'CEO ',
    company: 'TechVision Inc',
    image: male1
  },
  {
    quote:
      "Colossal Innovation's Salesforce consulting services have been invaluable to our company. Their team of experts understood our unique business needs and implemented a tailored solution that exceeded our expectations. Their professionalism and commitment to excellence have made them a trusted partner for all our CRM needs.",
    author: 'Emily Johnson',
    position: 'Marketing Manager',
    company: 'GlobalTech Solutions',
    image: female1
  },
  {
    quote:
      "We engaged Colossal Innovation for our web development project, and they delivered outstanding results. Their team's technical expertise, attention to detail, and ability to meet deadlines were commendable. They transformed our vision into a stunning website that has greatly enhanced our online presence. We are extremely satisfied with their services.",
    author: 'David Thompson',
    position: 'COO',
    company: 'WebWizards Ltd',
    image: male2
  },
  {
    quote:
      "Colossal Innovation's business application development services have transformed our operations. Their team understood our complex requirements and developed a scalable solution that streamlined our processes. The professionalism and dedication they exhibited throughout the project were exemplary. We are thrilled with the outcome and highly recommend their services.",
    author: 'Sarah Anderson',
    position: 'CFO',
    company: 'Enterprise Solutions Inc',
    image: female2
  },
  {
    quote:
      "We have been working with Colossal Innovation for data visualization and advanced analytics, and it has been an exceptional experience. Their team's deep understanding of data analytics coupled with their ability to present insights in a visually appealing manner has helped us make data-driven decisions with confidence. Their expertise has been instrumental in our success.",
    author: 'Michael Roberts',
    position: 'Director of Analytics ',
    company: 'DataDriven',
    image: male3
  },
  {
    quote:
      "Colossal Innovation's consultancy services have been instrumental in our business growth. Their strategic insights and guidance have helped us navigate complex challenges and seize new opportunities. Their team's expertise, professionalism, and dedication to our success have made them an invaluable resource.",
    author: 'David Thompson',
    position: 'CEO ',
    company: 'InnovateNow Corporation',
    image: male4
  },
  {
    quote:
      "Colossal Innovation has played a vital role in our digital transformation journey. Their expertise in data analytics and advanced technologies has helped us optimize our operations and drive efficiencies. Their team's dedication, technical skills, and customer-centric approach have exceeded our expectations.",
    author: 'Rachel Carter',
    position: 'COO ',
    company: 'DigitalEdge Solutions',
    image: female3
  },
  {
    quote:
      "We are thrilled with the results achieved through Colossal Innovation's services. Their expertise in Salesforce integration and customization has helped us streamline our sales processes and improve customer engagement. Their team's attention to detail, promptness, and support have been exceptional.",
    author: 'John Smith',
    position: 'Sales Manager',
    company: 'InnovateTech Inc',
    image: male5
  },
  {
    quote:
      "Colossal Innovation has been a reliable partner in our data analytics initiatives. Their advanced analytics solutions have enabled us to uncover valuable insights and make data-driven decisions. Their team's expertise, professionalism, and commitment to our success have made them a trusted advisor.",
    author: 'Amanda Davis',
    position: 'Sales Director',
    company: 'SuccessPro Inc',
    image: female4
  },
  {
    quote:
      "Colossal Innovation's web development services have exceeded our expectations. They created a visually stunning and user-friendly website that perfectly represents our brand. Their team's creativity, technical expertise, and prompt communication made the entire process seamless and enjoyable.",
    author: 'Robert Anderson',
    position: 'Marketing Manager',
    company: 'DigitalWorks Ltd',
    image: male6
  },
  {
    quote:
      "Colossal Innovation's expertise in business application development has revolutionized our workflows. They delivered a custom solution that streamlined our processes, improved efficiency, and enhanced collaboration. Their team's technical prowess, attention to detail, and customer-centric approach have been exceptional.",
    author: 'Allison Maiden',
    position: 'COO ',
    company: 'TechGenius Solutions',
    image: female5
  }
];

export const services = [
  {
    id: 1,
    image: cloudApp,
    title: 'Cloud Native Apps',
    description:
      'Optimize your resources, scale with ease and deploy rapidly to reduce time-to-market'
  },
  {
    id: 2,
    image: mobileDevelopment,
    title: 'Mobile & PWA',
    description:
      "We help deliver your businesses' value directly to palm of your customers hand"
  },
  {
    id: 3,
    image: analytics,
    title: 'Analytics & Visualization',
    description:
      'We provide real-time insights and granular reports, and help you make data-based decisions at every level'
  },
  {
    id: 4,
    image: customDevelopment,
    title: 'Custom Development',
    description:
      'Tailored to your specific needs, using the latest technologies and best practices'
  },
  {
    id: 5,
    image: enterpriseDevelopment,
    title: 'Enterprise Software Development',
    description:
      'Solutions for large organizations with a focus on security, performance & reliability'
  },
  {
    id: 6,
    image: eCommerce,
    title: 'E-Commerce Solutions',
    description:
      'Solutions to help sell your products online, with secure and easy-to-use e-commerce platforms'
  },
  {
    id: 7,
    image: webDevelopment,
    title: 'Web Development',
    description:
      'Responsive and optimized for search engines and designed to convert visitors to paying customers'
  },
  {
    id: 8,
    image: uiUx,
    title: 'UI/UX Development',
    description:
      'We create interfaces that seamlessly guide users through your digital ecosystem'
  },
  {
    id: 9,
    image: salesforce,
    title: 'Salesforce Services',
    description:
      'Unleash the true potential of Salesforce with our comprehensive range of services, from consulting to implementation and ongoing support.'
  },
  {
    id: 10,
    image: freeConsult,
    title: 'Free Consult',
    description:
      'We will assess your current strategies, processes, and technology landscape to identify opportunities for improvement and innovation'
  }
];

export const teamMembers = [
  {
    image: muhammadFaizan,
    name: 'Muhammad Faizan',
    position: 'Co-Founder & CEO',
    linkedIn: 'https://www.linkedin.com/in/syed-faizan-mazhar-5bb99b3/',
    twitter: 'https://twitter.com/',
    instagram: 'https://instagram.com'
  },
  {
    image: saadAli,
    name: 'Saad Ali',
    position: 'COO',
    linkedIn: 'https://www.linkedin.com/in/saad-ali-6500705b/',
    twitter: 'https://twitter.com/',
    instagram: 'https://instagram.com'
  }
];
